<template>
  <nav>
    <ul class="list-none m-0 p-0">
      <li v-for="(crumb, index) in crumbs" :key="index" class="inline-block mr-[10px]">
        <router-link v-if="crumb.to" :to="crumb.to" class="text-indigo-500 cursor-pointer underline text-sm font-semibold">
          {{ crumb.text }}
        </router-link>
        <span v-else class="text-[#64648B] cursor-pointer text-sm font-semibold">
          {{ crumb.text }}
        </span>
        <span v-if="index < crumbs.length - 1" class="text-[#64648B]"> > </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    crumbs: {
      type: Array,
      required: true,
      validator: (value) => value.every((crumb) => crumb && typeof crumb.text === 'string' && (crumb.to === undefined || typeof crumb.to === 'string')),
    },
  },
};
</script>

<style scoped></style>